import React from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

import CustomTitle from './title';

CustomTableHead.propTypes = {
  columns: PropTypes.array.isRequired,
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

HeaderTitleSorted.defaultProps = {
  active: false,
  direction: 'asc',
};

HeaderTitleSorted.propTypes = {
  active: PropTypes.bool.isRequired,
  direction: PropTypes.oneOf(['asc', 'desc']).isRequired,
};

function HeaderTitleSorted({ children, ...props }) {
  return (
    <TableSortLabel
      active={props.active}
      direction={props.direction}
      onClick={props.onClick}
    >
      <CustomTitle>{children}</CustomTitle>
    </TableSortLabel>
  );
}

export default function CustomTableHead({ children, ...props }) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding='checkbox'>
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all desserts' }}
          />
        </TableCell>
        {Array.isArray(props.columns) &&
          props.columns.map((column) => (
            <TableCell
              key={column.id}
              align={column.align || 'justify'}
              padding={column.padding || 'default'}
              sortDirection={orderBy === column.id ? order : false}
            >
              {column.sortable === true && <CustomTitle>{column}</CustomTitle>}
              {column.sortable === false && (
                <HeaderTitleSorted
                  classes={classes}
                  active={orderBy === column.id}
                  direction={orderBy === column.id ? order : 'asc'}
                  onClick={createSortHandler(column.id)}
                >
                  {column}
                </HeaderTitleSorted>
              )}
            </TableCell>
          ))}
      </TableRow>
    </TableHead>
  );
}
